export default __webpack_public_path__ + "static/media/scribs.322ee7cf.png";